var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 26 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.5 2.174h25V23.5H.5V2.174ZM1.13 7.256H26M5.652 0v4.465M20.35 0v4.465M5.652 12.837h2.261M11.87 12.837h2.26M18.088 12.837h2.26M5.652 17.86h2.261M11.87 17.86h2.26M18.088 17.86h2.26",
  stroke: "currentColor"
})));

export default SvgIconCalendar;